var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "bg-brand-secondary font-archivo-narrow" }, [
    _c(
      "div",
      {
        staticClass:
          "container py-3 flex mx-auto px-1 flex-wrap justify-around lg_justify-between md_py-5"
      },
      [
        _vm._l(_vm.columns, function(links, title) {
          return _c("footer-column", {
            key: title,
            attrs: {
              title: title,
              links: links,
              "open-default": title === "Company",
              height: _vm.heights[title]
            }
          })
        }),
        _c(
          "div",
          {
            staticClass:
              "flex w-full mt-2 md_mt-3 lg_w-1-2 lg_mt-0 justify-around flex-wrap"
          },
          [_c("footer-social"), _c("footer-currency")],
          1
        )
      ],
      2
    )
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }